/* unplugin-vue-components disabled */import script from "./IndexView.vue?vue&type=script&lang=tsx&setup=true"
export * from "./IndexView.vue?vue&type=script&lang=tsx&setup=true"

import "./IndexView.vue?vue&type=style&index=0&id=374c6896&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-374c6896"]])

export default __exports__